<template>
  <form class="form-part-diagnoses" v-on:submit.prevent="onSubmit">
    <div class="form-part-diagnoses__diagnoses">
      <label
        class="item"
        v-bind:class="deletedValue">
        <input
          type="button"
          v-bind:disabled="onlyView"
          v-on:click="onChangeDeleted(deletedValue)" />
        <span>Зуб удален</span>
      </label>
      <div
        v-for="part in sortedParts"
        v-bind:key="part.id">
        <h3 class="form-part-diagnoses__title">{{ part.name }}</h3>
        <div class="form-part-diagnoses__items">
          <label
            class="item"
            v-for="({ diagnosis, value }) in part.diagnoses"
            v-bind:key="diagnosis.id"
            v-bind:class="value"
            v-bind:style="{ backgroundColor: diagnosis.color }">
            <input
              type="button"
              v-bind:disabled="onlyView"
              v-on:click="onClick(part.id, diagnosis.id, value)" />
            <span>{{diagnosis.name}}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="form-part-diagnoses__buttons">
      <button
        v-if="onlyView"
        class="form-part-diagnoses__button-cancel"
        type="button"
        v-on:click="onCancel">
        Закрыть
      </button>
      <template v-else>
        <button
          class="form-part-diagnoses__button-cancel"
          type="button"
          v-on:click="onCancel">
          Отмена
        </button>
        <button
          class="form-part-diagnoses__button-ok"
          type="submit">
          ОК
        </button>
      </template>
    </div>
  </form>
</template>

<script>

export default {
  computed: {
    sortedParts: ({ partList }) => partList.sort((a, b) => a.id > b.id),
  },
  methods: {
    onSubmit() {
      this.$emit('submit');
    },
    onCancel() {
      this.$emit('cancel');
    },
    onClick(partId, diagnosisId, currentValue) {
      const isSelected = this.isSelected(currentValue);
      this.$emit('change-diagnoses', partId, diagnosisId, isSelected);
    },
    /**
     * @description Обработать удаление.
     * @param {string} currentValue Текущее значение.
     * @returns {void}
     */
    onChangeDeleted(currentValue) {
      this.$emit('change-tooth-deleted', this.isSelected(currentValue));
    },
    isSelected(currentValue) {
      return ['any', 'empty'].includes(currentValue);
    },
  },
  inject: ['onlyView'],
  props: {
    /**
     * @description Части зуба.
     * @type {Part[]}
     */
    partList: { type: Array, required: true },
    /**
     * @description Удален.
     * @type {string}
     */
    deletedValue: { type: String, required: true },
  },
  name: 'FormPartDiagnoses',
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.form-part-diagnoses {
  min-width: 263px;
  padding: 0 0 20px 20px;
  max-height: 400px;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 20px;
  &__diagnoses {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 20px 20px 0 0;
    position: relative;
  }
  &__title {
    color: #000000;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    text-align: left;
    margin: 0 0 12px 0;
  }
  &__items {
    display: flex;
    flex-direction: column;
    gap: 7px;
  }
  &__buttons {
    padding-right: 20px;
    display: flex;
    flex-direction: row;
    gap: 6px;
  }
  &__button {
    &-cancel {
      @include buttons.btn-transparent(100%, 40px, 16px);
      max-width: 95px;
    }
    &-ok {
      @include buttons.btn-blue(100%, 40px, 16px);
    }
  }
}
.item {
  display: flex;
  padding: 4px 8px 4px 4px;
  border-radius: 4px;
  color: #192a3e;
  cursor: pointer;
}
.item>input {
  opacity: 0;
  position: absolute;
  z-index: -1;
}
.item>input:focus+span::before {
  border-color: var(--action-color);
}
.item>span {
  align-items: center;
  display: inline-flex;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  user-select: none;
  cursor: pointer;
}
.item>span::before {
  background-color: var(--primary-background-color);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 70%;
  border: 1px solid var(--unfocus-color);
  border-radius: 4px;
  content: '';
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  height: 1.5rem;
  margin: 0 10px 0 0;
  width: 1.5rem;
}
.any>span::before {
  background-color: var(--action-color);;
  background-image: url("@/assets/img/minus.svg");
}
.all>span::before {
  background-color: var(--action-color);
  background-image: url("@/assets/img/checked/checked-white-top.svg");
}
.selected>input:focus+span::before {
  border-color: black;
}
.empty>span::before{
  background-color: var(--primary-background-color);
  background-image: none;
}
</style>
